import { createContext, useContext, useState } from 'react';
import { getCurrentWeekDates } from 'Helper/dateHelpers';

const ScheduleContext = createContext();

const initialAlertProps = {
  isOpen: false,
  title: '',
  description: '',
  type: 'success',
  onClose: null,
};

const initialState = {
  isOpenFormUpsert: false,
  initialSelectedSchedule: { startedAt: null, endedAt: null },
  isEditFormUpsert: false,
  isOpenFormUpload: false,
  isUploadLoad: false,
  uploadLoadValue: 0,
  selectedEvent: null,
  isDrawerOpen: false,
  isEnableFetchDetail: false,
  isDialogOpen: false,
  clickPosition: null,
  alertProps: initialAlertProps,
};

const initialFilterState = {
  brand: null,
  account: null,
  platform: null,
  host: null,
  studio: null,
  operator: null,
  area: null,
  dateRange: getCurrentWeekDates(),
  viewType: { value: 3, label: '3 Days' },
};

const ScheduleProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(initialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const updateFilterState = (payload) => setFilterState((prev) => ({ ...prev, ...payload }));
  const resetState = () => setState(initialState);
  const resetFilterState = () => setFilterState(initialFilterState);
  const resetAlertProps = () => setState((prev) => ({ ...prev, alertProps: initialAlertProps }));

  return (
    <ScheduleContext.Provider value={{ updateState, updateFilterState, resetState, resetFilterState, resetAlertProps, state, filterState }}>
      {children}
    </ScheduleContext.Provider>
  );
};

export const useScheduleState = () => {
  return useContext(ScheduleContext);
};

export default ScheduleProvider;
